import { render, staticRenderFns } from "./tool-compare.vue?vue&type=template&id=3dddd18b&scoped=true"
import script from "./tool-compare.vue?vue&type=script&lang=js"
export * from "./tool-compare.vue?vue&type=script&lang=js"
import style0 from "./tool-compare.vue?vue&type=style&index=0&id=3dddd18b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dddd18b",
  null
  
)

export default component.exports